import type { ListingSortOption } from 'api/utils/listingMapper';

export const SORT_URL_VALUES: ListingSortOption[] = ['newest', 'oldest', 'priceAsc', 'priceDesc'];

/** Legacy query strings from earlier URL experiments. */
const LEGACY_SORT_ALIASES: Record<string, ListingSortOption> = {
  price_asc: 'priceAsc',
  price_desc: 'priceDesc',
};

export function parseListingPageParam(raw: string | null): number {
  const n = parseInt(raw ?? '1', 10);
  return Number.isFinite(n) && n >= 1 ? n : 1;
}

export function parseListingSortParam(raw: string | null): ListingSortOption {
  if (!raw) return 'newest';
  if (SORT_URL_VALUES.includes(raw as ListingSortOption)) {
    return raw as ListingSortOption;
  }
  const legacy = LEGACY_SORT_ALIASES[raw];
  if (legacy) return legacy;
  return 'newest';
}
